export default {"src":"/_next/static/media/search.42b407d3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};